<template>
    <v-list
			:style="listStyle"
			dense
      class="pb-0"
		>
        <template v-for="(lineItem, index) in lineItems">
            <LineItemListItem :key="lineItem.uuid" :line-item="lineItem" :order-state="orderState" />
            <v-divider :key="index" v-if="index < lineItems.length - 1" />
        </template>
    </v-list>
</template>

<script>

export default {
    name: 'LineItemList',
    props: {
      lineItems: {
        type: Array,
				required: true
			},
      orderState: {
        type: String,
        required: false,
        default: null
      },
			maxHeight: {
        type: Number,
				required: false,
        default: null
			}
		},
    components: {
        'LineItemListItem': () => import('./LineItemListItem.vue')
    },
	computed: {
    listStyle() {
      if(this.maxHeight !== null && typeof this.maxHeight !== 'undefined') {
        return 'overflow-y: scroll; background-color: transparent; max-height: ' + this.maxHeight + 'px;'
			}
      return 'overflow-y: scroll; background-color: transparent'
		}
	}
}
</script>
